// ThemeContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';

export const applyThemeVars = (theme) => {
  const themeMap = {
    glass: { theme: 'rgba(64, 64, 64, 0.3)', text: 'aliceblue', placeholder: 'rgba(200, 200, 200, 0.8)', border: '1px solid rgba(255, 255, 255, 0.2)', alt: 'rgba(255, 255, 255, 0.06)' },
    light: { theme: 'rgba(255, 255, 255, 0.7)', text: 'black', placeholder: '#888', border: '1px solid transparent', alt: 'rgba(0, 0, 0, 0.05)' },
    dark:  { theme: 'rgba(64, 64, 64, 0.7)', text: 'aliceblue', placeholder: 'rgba(200, 200, 200, 0.8)', border: '1px solid transparent', alt: 'rgba(255, 255, 255, 0.04)' },
  };
  const th = themeMap[theme] || themeMap.light;
  document.documentElement.style.setProperty('--theme', th.theme);
  document.documentElement.style.setProperty('--textTheme', th.text);
  document.documentElement.style.setProperty('--placeholderTheme', th.placeholder);
  document.documentElement.style.setProperty('--borderTheme', th.border);
  document.documentElement.style.setProperty('--altRow', th.alt);
};

export const getSystemTheme = () =>
  window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';

const ThemeContext = createContext({
  themeMode: 'light',
  setThemeMode: () => {},
  resolvedTheme: 'light',
});

export const ThemeProvider = ({ children }) => {
  const [themeMode, setThemeMode] = useState(''); // '' = "not loaded from server yet"
  const [resolvedTheme, setResolvedTheme] = useState(getSystemTheme());

  useEffect(() => {
    if (themeMode === '') return; // nothing to resolve yet

    const resolve = () => (themeMode === 'auto' ? getSystemTheme() : themeMode);

    const update = () => {
      const resolved = resolve();
      setResolvedTheme(resolved);
      applyThemeVars(resolved);
    };

    update();

    if (themeMode === 'auto') {
      const mql = window.matchMedia('(prefers-color-scheme: dark)');
      mql.addEventListener('change', update);
      return () => mql.removeEventListener('change', update);
    }
  }, [themeMode]);

  return (
    <ThemeContext.Provider value={{ themeMode, setThemeMode, resolvedTheme, setResolvedTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useThemeMode = () => useContext(ThemeContext);